import React from "react";
import { string } from "prop-types";
import InputGroup from "../InputGroup";
import Icon from "../Icon";
import Input from "../Input";
import { classes } from "../utils/classes";

const AutocompleteField = ({ className = "", iconName = "search", ...props }) => (
	<InputGroup className={classes("autocomplete__field", className)}>
		<InputGroup.Prepend>
			<Icon name={iconName} />
		</InputGroup.Prepend>
		<InputGroup.Field>
			<Input type="search" {...props} />
		</InputGroup.Field>
	</InputGroup>
);

AutocompleteField.propTypes = {
	className: string,
	iconName: Icon.propTypes.name,
};

export default AutocompleteField;
